import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken() {
  return Cookies.get(TokenKey)
  // return 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJ3ZWIiLCJpc3MiOiJ3bS10aXMiLCJleHAiOjE2NTgxNDEyMTEsImlhdCI6MTY1ODEwNTIxMSwianRpIjoiMzIyNzQ1OWEzZTA1NGNiYWI0MTBlODY1NTJmMTg2ODAiLCJ1c2VybmFtZSI6InNpeXVhbi5zaGFuZyJ9.fN3taSDcP6QmiDlDwNE2t6ZgkGYduhZV9E8Ha2-VjHU'
  }

export function setToken(token) {
   return Cookies.set(TokenKey, token)
  // return 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJ3ZWIiLCJpc3MiOiJ3bS10aXMiLCJleHAiOjE2NTgxNDEyMTEsImlhdCI6MTY1ODEwNTIxMSwianRpIjoiMzIyNzQ1OWEzZTA1NGNiYWI0MTBlODY1NTJmMTg2ODAiLCJ1c2VybmFtZSI6InNpeXVhbi5zaGFuZyJ9.fN3taSDcP6QmiDlDwNE2t6ZgkGYduhZV9E8Ha2-VjHU'
  }

export function removeToken() {
  return Cookies.remove(TokenKey)
}
